import { AppBar, Box, SvgIcon, Toolbar, Typography } from '@mui/material';
import AppMenu from './AppMenu.jsx';
import DashBoardIcon from '~/assets/dashboard_icon.svg';
import ProfileMenu from './ProfileMenu.jsx';

const companyLogo = import.meta.env.VITE_COMPANY_LOGO || '/icons.svg';

function Header() {
  return (
    <AppBar
      position="static"
      color="primary"
      elevation={0}
      sx={{
        borderBottom: '3px solid #d7dbe8',
      }}>
      <Toolbar
        disableGutters
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          minHeight: '55px',
          px: 2,
          '@media (min-width: 600px)': {
            minHeight: '55px',
          },
        }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 1.5,
            minWidth: 0,
          }}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              gap: 1.4,
              minWidth: 0,
            }}>
            <SvgIcon
              inheritViewBox
              component={DashBoardIcon}
              sx={{
                height: 36,
                width: 42,
              }}
            />
            <Typography
              variant="h5"
              sx={{
                color: '#fff',
                lineHeight: 1,
              }}>
              Dashboard
            </Typography>
          </Box>
        </Box>

        <Box
          alt="Company logo"
          component="img"
          src={companyLogo}
          sx={{
            display: 'block',
            height: 34,
            maxWidth: 180,
            objectFit: 'contain',
          }}
        />

        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 1.2,
            justifyContent: 'flex-end',
          }}>
          <AppMenu />
          <ProfileMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
